"use strict";
/********************************************************************************
  HxActorWithResultsCompletion.ts

  Actor With Results API now returns HxActorWithResultsCompletion<T>
  HxActorWithResultsCompletion returns a promise for the Results (resultsAvailable)
  and a promise for the completion results (completionOnSpecifiedCheckpoint).
  Clients should call await HxActorWithResultsCompletion.resultsAvailable to get results.
  HxActorWithResultsCompletion.resultsAvailable will return Success or reject the promise with Failure Results.
  Clients can specify a checkpoint and they can hear if the action has succeeded or not on that checkpoint.
  Clients can get checkpoint results by calling await HxActorWithResultsCompletion.completionOnSpecifiedCheckpoint

  Copyright (c) Microsoft Corporation. All rights reserved.
********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxActorWithResultsCompletion = void 0;
var HxActorWithResultsCompletion = /** @class */ (function () {
    function HxActorWithResultsCompletion(requestIdForUndo, resultsAvailable, actionCompleted) {
        this.requestIdForUndo = requestIdForUndo;
        this.resultsAvailable = resultsAvailable;
        this.completionOnSpecifiedCheckpoint = actionCompleted;
    }
    return HxActorWithResultsCompletion;
}());
exports.HxActorWithResultsCompletion = HxActorWithResultsCompletion;
exports.default = HxActorWithResultsCompletion;
